import camelCase from 'lodash/camelCase';
import { navigationActions } from '../../../actions';
import { segmentConfigSelectors } from '../../../selectors';
import * as analyticsEvents from '../events';

export default (state, { type, ...action }) => {
  switch (type) {
    case navigationActions.NEXT_SEGMENT: {
      const currentSegmentName =
        segmentConfigSelectors.getCurrentSegmentName(state);

      return analyticsEvents.trackPageView({
        ...(action.payload || {}),
        keyPath: {
          pageName: camelCase(currentSegmentName),
        },
        state,
      });
    }

    case navigationActions.NEXT_PAGE:

    case navigationActions.PREV_PAGE: {
      const currentPageName = segmentConfigSelectors.getCurrentPageName(state);

      return analyticsEvents.trackPageView({
        ...(action.payload || {}),
        keyPath: {
          pageName: camelCase(currentPageName),
        },
        state,
      });
    }

    default:
      return null;
  }
};
